<template>
  <div class="w-100 d-flex m-0 p-0 fill-height">
    <v-card
      :style="{ background: bg.bodyColor }"
      class="hide-scrollbar fill-height rounded-b-0 rounded-tl-0"
      flat
      width="55px"
    >
      <v-tabs
        v-model="tab"
        background-color="transparent"
        class="fill-height"
        hide-slider
        show-arrows
        vertical
      >
        <v-tab
          v-for="(item, index) in value"
          :key="index"
          class="px-0 py-8"
          style="height: 15rem; min-width: 55px; width: 55px"
          :value="'option-' + (index + 1)"
          @click="getInfo(index)"
        >
          <div class="marquee-container">
            <div class="active-tab--bg" />
            <span
              ref="tabText"
              :class="{
                'marquee-text': isTextMarquee[index],
                rtl: isRtl(item.name),
              }"
              :style="{ color: tab !== index ? textColor : '' }"
              class="d-block"
              >{{ item.name }}</span
            >
          </div>
        </v-tab>
      </v-tabs>
    </v-card>

    <v-card
      class="transparent flex overflow-y-auto custom-scrollbar"
      flat
      max-height="100%"
    >
      <v-row class="pa-2" no-gutters>
        <v-col
          v-for="(item, i) in value"
          :id="`extra-col-${i}`"
          :key="i"
          class="pb-4"
          cols="12"
          style="height: fit-content"
        >
          <v-icon v-show="index === i" color="primary" right>{{
            item.icon
          }}</v-icon>
          <b :class="{ 'primary--text font-size-h5': index === i }">{{
            item.name
          }}</b>
          <extra-shown v-model="item.value" font-color="black" />
          <v-divider style="border: 1px solid rgba(0, 0, 0, 0.5)" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ExtraShown from "../../components/Product/extraShown";

export default {
  name: "secondPage",
  components: { ExtraShown },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    bg: {
      type: Object,
      default: () => ({ bodyColor: "#f0f0f0" }),
    },
  },
  data() {
    return {
      tab: "option-1",
      relatedInfo: [],
      index: 0,
      isTextMarquee: [],
    };
  },
  mounted() {
    this.checkTextLength();
    window.addEventListener("resize", this.checkTextLength);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkTextLength);
  },
  computed: {
    textColor() {
      const color = this.bg.bodyColor;
      if (color && color.includes("linear-gradient")) {
        const matches = color.match(/#[0-9a-fA-F]{6}(?:[0-9a-fA-F]{2})?/g) || [
          "#ffffff",
        ];
        let minLuminance = 1;
        let closestToBlack = false;

        matches.forEach((hex) => {
          const rgb = this.hexToRgb(hex.length === 9 ? hex.slice(0, 7) : hex);
          if (rgb) {
            const r = rgb.r / 255;
            const g = rgb.g / 255;
            const b = rgb.b / 255;
            const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            // Calculate distances
            const distanceToWhite = Math.abs(luminance - 1); // White luminance = 1
            const distanceToBlack = Math.abs(luminance); // Black luminance = 0

            // Update if this color has the lowest luminance (darkest)
            if (luminance < minLuminance) {
              minLuminance = luminance;
              closestToBlack = distanceToBlack < distanceToWhite;
            }
          }
        });
        return closestToBlack ? "#ffffff" : "#000000";
      }

      // Handle single color
      const representativeColor = this.extractRepresentativeColor(color);
      const rgb = this.hexToRgb(representativeColor);
      if (!rgb) return "#ffffff";

      const r = rgb.r / 255;
      const g = rgb.g / 255;
      const b = rgb.b / 255;
      const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

      const distanceToWhite = Math.abs(luminance - 1);
      const distanceToBlack = Math.abs(luminance);
      return distanceToBlack < distanceToWhite ? "#ffffff" : "#000000";
    },
  },
  methods: {
    getInfo(index) {
      this.index = index;
      let el = document.getElementById(`extra-col-${index}`);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    extractRepresentativeColor(color) {
      if (color && color.includes("linear-gradient")) {
        const matches = color.match(/#[0-9a-fA-F]{6}(?:[0-9a-fA-F]{2})?/g) || [
          "#ffffff",
        ];
        // Return the first color for consistency with single-color logic
        return matches[0].length === 9 ? matches[0].slice(0, 7) : matches[0];
      }
      if (color && color.match(/rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/)) {
        return color;
      }
      if (color && color.match(/#[0-9a-fA-F]{6}(?:[0-9a-fA-F]{2})?/)) {
        return color.length === 9 ? color.slice(0, 7) : color;
      }
      return "#ffffff";
    },
    isColorDark(color) {
      const rgb = this.hexToRgb(color);
      if (!rgb) return false;

      const r = rgb.r / 255;
      const g = rgb.g / 255;
      const b = rgb.b / 255;

      const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      return luminance < 0.6;
    },
    hexToRgb(hex) {
      hex = hex.replace(/^#/, "");
      let r, g, b;

      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else if (hex.length === 6) {
        r = parseInt(hex.slice(0, 2), 16);
        g = parseInt(hex.slice(2, 4), 16);
        b = parseInt(hex.slice(4, 6), 16);
      } else {
        return null;
      }

      return { r, g, b };
    },
    isRtl(text) {
      const rtlRegex = /[\u0600-\u06FF\u0750-\u077F]/;
      return rtlRegex.test(text);
    },
    checkTextLength() {
      document.fonts.ready.then(() => {
        this.$nextTick(() => {
          const tabs = this.$refs.tabText;
          if (!tabs) {
            console.log("No tabText refs found");
            return;
          }
          this.isTextMarquee = Array.isArray(tabs)
            ? tabs.map((tab, index) => {
                const tabHeight = tab.parentElement.offsetHeight;
                const textRect = tab.getBoundingClientRect();
                const textHeight = textRect.height;
                return textHeight > tabHeight - 10;
              })
            : [];
        });
      });
    },
  },
};
</script>

<style scoped>
#creativeTab .theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}

#creativeTab .v-tab--active .negin {
  content: "";
  width: 8rem;
  height: 12.5rem;
  display: block;
  transform: translateX(-15px);
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("/media/bg/tabs.svg");
  position: absolute;
  color: black;
}

#creativeTab .v-tab--active p {
  transform: rotate(90deg) translateY(10px) !important;
}

.marquee-container {
  overflow: hidden;
  position: relative;
  height: 15rem; /* ارتفاع کامل تب */
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.marquee-text {
  position: absolute;
  top: 0;
  animation: marquee 8s linear infinite;
  white-space: nowrap;
  will-change: transform;
}

.rtl {
  direction: rtl;
  text-align: right;
}

.marquee-text.rtl {
  animation: marquee-rtl 8s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(calc(-100% + 5rem));
  }
}

@keyframes marquee-rtl {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(calc(-100% + 5rem));
  }
}

.v-tabs >>> .v-slide-group__wrapper {
  overflow-y: auto;
}

.v-tabs >>> .v-slide-group__wrapper::-webkit-scrollbar {
  display: none;
}

.v-tabs >>> .v-tab {
  height: 15rem;
  min-width: 55px;
  width: 55px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.v-tabs >>> .v-tab::before {
  display: none;
}

.v-tabs >>> .v-tab.v-tab--active span {
  padding-right: 8px;
}

.v-tabs >>> .v-tab:not(.v-tab--active) .active-tab--bg {
  display: none;
}

.active-tab--bg {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 75%;
  height: calc(100% - 48px);
  transform: translateY(-50%);
  background-color: #fff;
  border-radius: 0 12px 12px 0;
  z-index: -1;
}

.active-tab--bg::before,
.active-tab--bg::after {
  content: "";
  width: 3.5rem;
  height: 1.5rem;
  position: absolute;
  box-shadow: -10px 5px 0 -3px #fff;
  border-radius: 50%;
  left: 0;
}

.active-tab--bg::before {
  top: 0;
  transform: translateY(-100%);
}

.active-tab--bg::after {
  bottom: 0;
  transform: translateY(100%) rotateX(-180deg);
}
</style>
